/*

Merge field format:
%%Name(Optional Default)(Optional Modifiers)%%

Modifiers are formatted as an operator followed by a value, repeated any number of times, in the desired order of operations (NOT PEMDAS).

Example: %%ask(5)(+1*3|5)%%
1. Take the value of "ask" from the query string.
2. Use "5" as value if ask is missing or empty.
3. Apply modifiers from left to right: add 1, then multiply by 5, then round to nearest 5.

Modifier operators:
+: addition
-: subtraction
*: multiplication
/: division
|: round
@: ceiling
_: floor

Date field format:
%%DATE(Optional Date Format)%%

Without a date format passed in, the default will be MMMM Do. An example of this is July 30th. 
The date field can be modified with any valid moment date format string, you can see those here: https://momentjs.com/docs/#/displaying/format/
*/

angular.module("survey").factory("merge", ["queryParser", merge])
function merge(queryParser) {
  function mergeString(str, params) {
    if (str) {
      var match;
      while (match = /%%(\w+?)(?:\((.+?)\))?(?:\((.+?)\))?%%/.exec(str)) {
        var matchingSubstring = match[0];
        var fieldName = match[1].toLowerCase();
        var defaultValue = match[2];
        var modifiers = match[3];

        // fetch value from query string; otherwise fall back to default if present; otherwise display nothing
        var newValue = params[fieldName] || defaultValue || ""

        // if the field name is "random", generate a random number
        // accepts modifiers for min and max values
        if (fieldName === 'random') {
          let randomMin, randomMax;
          if (defaultValue) {
            randomMin = defaultValue.split(",")[0];
            randomMax = defaultValue.split(",")[1];
          }
          function getRandomInt(min=0, max=100000) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
          }
          newValue = getRandomInt(randomMin, randomMax);
        }
        
        if (fieldName === 'date') {
          const date = new Date();
          if (defaultValue) {
            newValue = moment(date).format(defaultValue);
          } else {
            newValue = moment(date).format('MMMM Do');
          }
        } else if (newValue && modifiers && fieldName !== 'date') {
          newValue = applyNumericModifiers(newValue, modifiers)
        }

        str = str.replace(matchingSubstring, newValue)
      }
    }
    return str
  }

  function applyNumericModifiers(value, modifiers) {
    if (typeof value === "string" && value.indexOf(",") !== -1) {
      // parse as array, e.g. for amounts= parameters
      var split = value.split(",").map(Number);
      if (split.filter(Number.isNaN).length) {
        return value;
      } else {
        value = split;
      }
    } else if (isNaN(parseFloat(value))) {
      return value;
    } else {
      value = parseFloat(value);
    }

    var originalModifiers = modifiers;
    var match;
    var rounded = false, floored = false;
    while (match = /([\+\-\/\*\_\@\|])([\d\.-]+)/.exec(modifiers)) {
      var matchingSubstring = match[0];
      var operator = match[1];
      var operand = parseFloat(match[2]);

      var operatorTransformations = {
        "+": x => x + operand,
        "-": x => x - operand,
        "*": x => x * operand,
        "/": x => x / operand,
        "|": x => {
          rounded = true;
          return Math.round(x / operand) * operand;
        },
        "@": x => Math.min(x, operand),
        "_": x => {
          floored = true;
          return Math.max(x, operand);
        }
      };
      var transformation = operatorTransformations[operator];

      value = Array.isArray(value) ? value.map(transformation) : transformation(value);

      modifiers = modifiers.replace(matchingSubstring, "");
    }

    if (modifiers) {
      // if there is something left in this string, the person who created this survey entered something invalid.
      console.log("There is a syntax error with the following modifier: " + originalModifiers);
      console.log("I did my best to apply it anyway, but it may not do what you wanted it to do. Please go back and check for typos.");
    }

    // Round to nearest whole # by default, if the user didn't provide something to round to,
    // as they might have done something like divide by 3 without thinking about floating point errors
    if (!rounded) {
      value = Array.isArray(value) ? value.map(i => Math.round(i)) : Math.round(value);
    }

    // Don't let numbers go below 0 unless the user gave their own floor value
    if (!floored) {
      value = Array.isArray(value) ? value.map(i => Math.max(0, i)) : Math.max(0, value);
    }
    
    if (Array.isArray(value)) {
      value = value.join(",");
    }

    return value;
  }

  function escapeDangerousCharacters(str) {
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/'/g,'&#xf27;').replace(/"/g, '&quot;').replace(/\//g, '&#x2F;');
  }

  function mergeAllProperties(obj, queryString) {
    var params = queryParser(queryString)
    
    for (var i in params) {
      // escape HTML special characters and quotes
      params[i] = escapeDangerousCharacters(params[i]);
      // convert params to lowercase so behavior is case-insensitive
      if (i !== i.toLowerCase()) {
        params[i.toLowerCase()] = params[i]
        params[i] = undefined;
      }
    }

    // merge all strings in the config, recursively.
    for (var prop in obj) {
      var value = obj[prop]
      if (typeof(value) === "string") {
        obj[prop] = mergeString(value, params)
      } else if (typeof(value) === "object") {
        mergeAllProperties(value, queryString)
      }
    }
  }

  return mergeAllProperties
}